import React, { useState, createElement, Component } from 'react';
import { SearchIcon, FilterIcon, MapPinIcon, PhoneIcon, MailIcon, GlobeIcon, ChevronDownIcon, UserIcon, UsersIcon, PlusIcon, DownloadIcon, StarIcon, ClipboardIcon, BuildingIcon, HeartPulseIcon, HelpCircleIcon, DollarSignIcon, NetworkIcon, CheckCircleIcon, FileTextIcon } from 'lucide-react';
const PayerContacts = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [expandedPayer, setExpandedPayer] = useState<number | null>(null);
  const toggleExpand = (id: number) => {
    if (expandedPayer === id) {
      setExpandedPayer(null);
    } else {
      setExpandedPayer(id);
    }
  };
  // Sample payer data
  const payers = [{
    id: 1,
    name: 'UnitedHealthcare',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/e/ef/UnitedHealth_Group_logo.svg',
    type: 'Commercial',
    memberCount: '45.2M',
    states: ['National'],
    contactInfo: {
      address: '9900 Bren Road East, Minnetonka, MN 55343',
      phone: '1-800-328-5979',
      email: 'medicalpolicies@uhc.com',
      website: 'https://www.uhcprovider.com'
    },
    keyContacts: [{
      name: 'Dr. Richard Johnson',
      title: 'Chief Medical Officer',
      department: 'Medical Policy',
      email: 'richard_johnson@uhc.com',
      phone: '1-800-328-5979 ext. 2345',
      photo: 'https://randomuser.me/api/portraits/men/32.jpg'
    }, {
      name: 'Sarah Williams',
      title: 'Director of Medical Policy',
      department: 'Medical Policy',
      email: 'sarah_williams@uhc.com',
      phone: '1-800-328-5979 ext. 3456',
      photo: 'https://randomuser.me/api/portraits/women/44.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://www.uhcprovider.com/en/policies-protocols/commercial-policies.html',
      reviewSchedule: 'Quarterly',
      commentPeriod: '30 days',
      nextReviewDate: '2025-09-15',
      committeeName: 'Medical Technology Assessment Committee',
      meetingFrequency: 'Monthly',
      policyContact: 'medicalpolicies@uhc.com'
    },
    notes: 'UnitedHealthcare has a formal reconsideration process for medical policies. Submit clinical evidence packages to medicalpolicies@uhc.com.'
  }, {
    id: 2,
    name: 'Aetna',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/4/4f/Aetna_logo.svg/1200px-Aetna_logo.svg.png',
    type: 'Commercial',
    memberCount: '25.3M',
    states: ['National'],
    contactInfo: {
      address: '151 Farmington Avenue, Hartford, CT 06156',
      phone: '1-860-273-0123',
      email: 'medicalpolicyinquiries@aetna.com',
      website: 'https://www.aetna.com'
    },
    keyContacts: [{
      name: 'Dr. Michael Chen',
      title: 'Senior Medical Director',
      department: 'Clinical Policy',
      email: 'chenm3@aetna.com',
      phone: '1-860-273-0123 ext. 4567',
      photo: 'https://randomuser.me/api/portraits/men/67.jpg'
    }],
    policyInfo: {
      policyWebsite: 'http://www.aetna.com/cpb/medical/data/cpb_index.html',
      reviewSchedule: 'Annual with quarterly updates',
      commentPeriod: '45 days',
      nextReviewDate: '2025-08-01',
      committeeName: 'Clinical Policy Council',
      meetingFrequency: 'Quarterly',
      policyContact: 'medicalpolicyinquiries@aetna.com'
    },
    notes: 'Aetna maintains a Clinical Policy Bulletin (CPB) system that is publicly accessible. New evidence can be submitted year-round.'
  }, {
    id: 3,
    name: 'Blue Cross Blue Shield of Florida',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/da/Blue_Cross_Blue_Shield_Association_Logo.svg/1200px-Blue_Cross_Blue_Shield_Association_Logo.svg.png',
    type: 'Commercial',
    memberCount: '5.2M',
    states: ['Florida'],
    contactInfo: {
      address: '4800 Deerwood Campus Parkway, Jacksonville, FL 32246',
      phone: '1-800-352-2583',
      email: 'medicalpolicy@floridablue.com',
      website: 'https://www.floridablue.com'
    },
    keyContacts: [{
      name: 'Dr. Elizabeth Martinez',
      title: 'Medical Director',
      department: 'Medical Policy',
      email: 'elizabeth.martinez@bcbsfl.com',
      phone: '1-800-352-2583 ext. 5678',
      photo: 'https://randomuser.me/api/portraits/women/33.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://www.floridablue.com/providers/tools-resources/medical-policies',
      reviewSchedule: 'Bi-annual',
      commentPeriod: '30 days',
      nextReviewDate: '2025-10-15',
      committeeName: 'Medical Policy & Technology Evaluation Committee',
      meetingFrequency: 'Bi-monthly',
      policyContact: 'medicalpolicy@floridablue.com'
    },
    notes: 'Florida Blue often follows BCBS Association national policies but maintains state-specific policies for certain procedures.'
  }, {
    id: 4,
    name: 'Cigna',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/7/72/Cigna_logo.svg/1200px-Cigna_logo.svg.png',
    type: 'Commercial',
    memberCount: '20.4M',
    states: ['National'],
    contactInfo: {
      address: '900 Cottage Grove Road, Bloomfield, CT 06002',
      phone: '1-800-997-1654',
      email: 'medicalpolicyfeedback@cigna.com',
      website: 'https://www.cigna.com'
    },
    keyContacts: [{
      name: 'Dr. Robert Thompson',
      title: 'National Medical Director',
      department: 'Coverage Policy',
      email: 'robert.thompson@cigna.com',
      phone: '1-800-997-1654 ext. 6789',
      photo: 'https://randomuser.me/api/portraits/men/41.jpg'
    }, {
      name: 'Jennifer Wilson',
      title: 'Director of Policy Development',
      department: 'Coverage Policy',
      email: 'jennifer.wilson@cigna.com',
      phone: '1-800-997-1654 ext. 7890',
      photo: 'https://randomuser.me/api/portraits/women/26.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://www.cigna.com/health-care-providers/coverage-and-claims/policies/',
      reviewSchedule: 'Quarterly',
      commentPeriod: '30 days',
      nextReviewDate: '2025-07-30',
      committeeName: 'Medical Coverage Policy Council',
      meetingFrequency: 'Monthly',
      policyContact: 'medicalpolicyfeedback@cigna.com'
    },
    notes: 'Cigna has a formal medical coverage policy reconsideration process. New clinical evidence can be submitted via their online portal.'
  }, {
    id: 5,
    name: 'Humana',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/80/Humana_logo.svg/1200px-Humana_logo.svg.png',
    type: 'Commercial/Medicare Advantage',
    memberCount: '17.1M',
    states: ['National'],
    contactInfo: {
      address: '500 West Main Street, Louisville, KY 40202',
      phone: '1-800-448-6262',
      email: 'medicalpolicyinput@humana.com',
      website: 'https://www.humana.com'
    },
    keyContacts: [{
      name: 'Dr. William Davis',
      title: 'Chief Medical Officer',
      department: 'Medical Policy',
      email: 'wdavis@humana.com',
      phone: '1-800-448-6262 ext. 8901',
      photo: 'https://randomuser.me/api/portraits/men/22.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://www.humana.com/provider/medical-resources/clinical-payment-policies',
      reviewSchedule: 'Annual',
      commentPeriod: '30 days',
      nextReviewDate: '2025-11-15',
      committeeName: 'Medical Policy Review Committee',
      meetingFrequency: 'Quarterly',
      policyContact: 'medicalpolicyinput@humana.com'
    },
    notes: 'Humana maintains separate policies for Commercial and Medicare Advantage plans. Check both when researching coverage.'
  }, {
    id: 6,
    name: 'Anthem',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/9/92/Anthem_Logo.svg/1200px-Anthem_Logo.svg.png',
    type: 'Commercial',
    memberCount: '40.8M',
    states: ['Multiple States'],
    contactInfo: {
      address: '220 Virginia Avenue, Indianapolis, IN 46204',
      phone: '1-800-331-1476',
      email: 'medicalpolicy@anthem.com',
      website: 'https://www.anthem.com'
    },
    keyContacts: [{
      name: 'Dr. James Wilson',
      title: 'VP Medical Policy',
      department: 'Medical Policy',
      email: 'james.wilson@anthem.com',
      phone: '1-800-331-1476 ext. 9012',
      photo: 'https://randomuser.me/api/portraits/men/52.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://www.anthem.com/provider/policies/',
      reviewSchedule: 'Quarterly',
      commentPeriod: '30 days',
      nextReviewDate: '2025-08-30',
      committeeName: 'Medical Policy & Technology Assessment Committee',
      meetingFrequency: 'Monthly',
      policyContact: 'medicalpolicy@anthem.com'
    },
    notes: 'Anthem policies often vary by state. Check the specific state policy website for regional variations.'
  }, {
    id: 7,
    name: 'Kaiser Permanente',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d1/Kaiser_Permanente_logo.svg/1200px-Kaiser_Permanente_logo.svg.png',
    type: 'Integrated Health System',
    memberCount: '12.6M',
    states: ['CA, CO, GA, HI, MD, OR, VA, WA, DC'],
    contactInfo: {
      address: 'One Kaiser Plaza, Oakland, CA 94612',
      phone: '1-800-464-4000',
      email: 'medical.policy@kp.org',
      website: 'https://www.kp.org'
    },
    keyContacts: [{
      name: 'Dr. Susan Lee',
      title: 'Director of Medical Technology Assessment',
      department: 'Technology Assessment',
      email: 'susan.lee@kp.org',
      phone: '1-800-464-4000 ext. 1234',
      photo: 'https://randomuser.me/api/portraits/women/62.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://healthy.kaiserpermanente.org/health/care/consumer/health-wellness',
      reviewSchedule: 'Bi-annual',
      commentPeriod: '45 days',
      nextReviewDate: '2025-09-30',
      committeeName: 'Interregional New Technologies Committee',
      meetingFrequency: 'Quarterly',
      policyContact: 'medical.policy@kp.org'
    },
    notes: 'Kaiser Permanente is an integrated health system with its own medical policies and technology assessment process.'
  }, {
    id: 8,
    name: 'Centene/Ambetter',
    logo: 'https://upload.wikimedia.org/wikipedia/commons/7/7c/Centene_Corporation_logo.svg',
    type: 'Commercial/Medicaid',
    memberCount: '26.5M',
    states: ['Multiple States'],
    contactInfo: {
      address: '7700 Forsyth Blvd, St. Louis, MO 63105',
      phone: '1-314-725-4477',
      email: 'clinicalpolicy@centene.com',
      website: 'https://www.centene.com'
    },
    keyContacts: [{
      name: 'Dr. Mary Johnson',
      title: 'SVP Medical Affairs',
      department: 'Clinical Policy',
      email: 'mary.johnson@centene.com',
      phone: '1-314-725-4477 ext. 2345',
      photo: 'https://randomuser.me/api/portraits/women/72.jpg'
    }],
    policyInfo: {
      policyWebsite: 'https://www.centene.com/products-and-services/clinical-policy.html',
      reviewSchedule: 'Annual',
      commentPeriod: '30 days',
      nextReviewDate: '2025-10-15',
      committeeName: 'Clinical Policy Committee',
      meetingFrequency: 'Bi-monthly',
      policyContact: 'clinicalpolicy@centene.com'
    },
    notes: 'Centene operates under multiple brands including Ambetter, Sunshine Health, and others depending on the state.'
  }];
  // Filter payers based on active filter and search term
  const filteredPayers = payers.filter(payer => {
    const matchesFilter = activeFilter === 'all' || payer.type.toLowerCase().includes(activeFilter.toLowerCase());
    const matchesSearch = payer.name.toLowerCase().includes(searchTerm.toLowerCase()) || payer.type.toLowerCase().includes(searchTerm.toLowerCase()) || payer.states.some(state => state.toLowerCase().includes(searchTerm.toLowerCase()));
    return matchesFilter && matchesSearch;
  });
  // Contact type buttons
  const contactTypes = [{
    name: 'Medical Directors',
    icon: HeartPulseIcon
  }, {
    name: 'Provider Relations',
    icon: UserIcon
  }, {
    name: 'Network Management',
    icon: NetworkIcon
  }, {
    name: 'Claims',
    icon: ClipboardIcon
  }, {
    name: 'Payment Integrity',
    icon: DollarSignIcon
  }, {
    name: 'Support',
    icon: HelpCircleIcon
  }];
  return <div className="px-4 py-6 md:px-6 lg:px-8 bg-slate-50" data-id="element-962">
      <div className="mb-6" data-id="element-963">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between" data-id="element-964">
          <div data-id="element-965">
            <h1 className="text-2xl font-bold text-gray-900" data-id="element-966">Payer Contacts</h1>
            <p className="mt-1 text-sm text-gray-500" data-id="element-967">
              Directory of insurance companies and key contacts for policy
              advocacy
            </p>
          </div>
          <div className="mt-4 md:mt-0 flex items-center space-x-3" data-id="element-968">
            <button className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 flex items-center" data-id="element-969">
              <DownloadIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-970" />
              Export Directory
            </button>
            <button className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-md hover:bg-blue-700 flex items-center" data-id="element-971">
              <UserIcon className="w-4 h-4 mr-2" data-id="element-972" />
              My Contacts
            </button>
          </div>
        </div>
      </div>

      {/* Search and filters */}
      <div className="flex flex-col items-stretch mb-6 space-y-4 md:flex-row md:items-center md:space-y-0 md:space-x-4" data-id="element-973">
        <div className="relative flex-grow" data-id="element-974">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none" data-id="element-975">
            <SearchIcon className="w-5 h-5 text-gray-400" data-id="element-976" />
          </div>
          <input type="text" className="block w-full py-2 pl-10 pr-3 text-sm border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" placeholder="Search payers by name, type, or state..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-977" />
        </div>
        <div className="flex space-x-4" data-id="element-978">
          <button className="flex items-center px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50" data-id="element-979">
            <FilterIcon className="w-4 h-4 mr-2 text-gray-500" data-id="element-980" />
            Filter
          </button>
          <select className="px-4 py-2 text-sm border border-gray-300 rounded-md bg-white shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500" value={activeFilter} onChange={e => setActiveFilter(e.target.value)} data-id="element-981">
            <option value="all" data-id="element-982">All Payer Types</option>
            <option value="Commercial" data-id="element-983">Commercial</option>
            <option value="Medicare" data-id="element-984">Medicare</option>
            <option value="Medicaid" data-id="element-985">Medicaid</option>
            <option value="Integrated" data-id="element-986">Integrated Systems</option>
          </select>
        </div>
      </div>

      {/* Payer rows */}
      <div className="space-y-6" data-id="element-987">
        {filteredPayers.map(payer => <div key={payer.id} className="overflow-hidden transition-all" data-id="element-988">
            <div className="flex flex-col lg:flex-row" data-id="element-989">
              {/* Company Information Section */}
              <div className="bg-white rounded-tl-lg rounded-tr-lg lg:rounded-tr-none lg:rounded-bl-lg shadow lg:w-1/3 p-6" data-id="element-990">
                <div className="flex items-center justify-between mb-4" data-id="element-991">
                  <div className="h-12 w-32 flex items-center" data-id="element-992">
                    <img src={payer.logo} alt={`${payer.name} logo`} className="max-h-12 max-w-full object-contain" onError={e => {
                  // If image fails to load, replace with company name
                  const target = e.target as HTMLImageElement;
                  target.onerror = null; // Prevent infinite loops
                  target.style.display = 'none';
                  // Create a fallback element with company initials
                  const parent = target.parentElement;
                  if (parent) {
                    const fallback = document.createElement('div');
                    fallback.className = 'h-10 w-10 bg-blue-100 rounded-md flex items-center justify-center text-blue-700 font-bold text-lg';
                    fallback.textContent = payer.name.split(' ')[0][0] + (payer.name.split(' ')[1]?.[0] || '');
                    parent.appendChild(fallback);
                  }
                }} data-id="element-993" />
                  </div>
                  <button className="p-1 text-gray-400 hover:text-yellow-500" data-id="element-994">
                    <StarIcon className="h-5 w-5" data-id="element-995" />
                  </button>
                </div>
                <h3 className="text-lg font-medium text-gray-900 mb-2" data-id="element-996">
                  {payer.name}
                </h3>
                <div className="flex items-center text-sm text-gray-500 mb-4" data-id="element-997">
                  <span className="px-2 py-1 text-xs font-medium bg-blue-100 text-blue-800 rounded-full" data-id="element-998">
                    {payer.type}
                  </span>
                  <span className="ml-2" data-id="element-999">{payer.memberCount} members</span>
                </div>
                <div className="space-y-2" data-id="element-1000">
                  <div className="flex items-start" data-id="element-1001">
                    <MapPinIcon className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1002" />
                    <span className="ml-2 text-sm text-gray-600" data-id="element-1003">
                      {payer.states.join(', ')}
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-1004">
                    <MapPinIcon className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1005" />
                    <span className="ml-2 text-sm text-gray-600" data-id="element-1006">
                      {payer.contactInfo.address}
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-1007">
                    <PhoneIcon className="h-5 w-5 text-gray-400" data-id="element-1008" />
                    <span className="ml-2 text-sm text-gray-600" data-id="element-1009">
                      {payer.contactInfo.phone}
                    </span>
                  </div>
                  <div className="flex items-center" data-id="element-1010">
                    <MailIcon className="h-5 w-5 text-gray-400" data-id="element-1011" />
                    <a href={`mailto:${payer.contactInfo.email}`} className="ml-2 text-sm text-blue-600 hover:text-blue-800" data-id="element-1012">
                      {payer.contactInfo.email}
                    </a>
                  </div>
                  <div className="flex items-center" data-id="element-1013">
                    <GlobeIcon className="h-5 w-5 text-gray-400" data-id="element-1014" />
                    <a href={payer.contactInfo.website} className="ml-2 text-sm text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer" data-id="element-1015">
                      Website
                    </a>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-1016">
                  <button className="text-sm font-medium text-blue-600 hover:text-blue-800 flex items-center" onClick={() => toggleExpand(payer.id)} data-id="element-1017">
                    {expandedPayer === payer.id ? <>
                        <ChevronDownIcon className="h-4 w-4 mr-1" data-id="element-1018" />
                        View Less
                      </> : <>
                        <ChevronDownIcon className="h-4 w-4 mr-1" data-id="element-1019" />
                        View Notes
                      </>}
                  </button>
                </div>
              </div>

              {/* Key Contacts Section */}
              <div className="bg-white lg:w-1/3 border-t lg:border-t-0 lg:border-l lg:border-r border-gray-200 p-6" data-id="element-1020">
                <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-1021">
                  Key Contacts
                </h4>
                {/* Chief Medical Officer */}
                {payer.keyContacts[0] && <div className="flex items-start mb-6" data-id="element-1022">
                    <div className="flex-shrink-0" data-id="element-1023">
                      <img src={payer.keyContacts[0].photo} alt={payer.keyContacts[0].name} className="h-16 w-16 rounded-full object-cover border-2 border-gray-200" onError={e => {
                  const target = e.target as HTMLImageElement;
                  target.onerror = null;
                  target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(payer.keyContacts[0].name)}&background=0D8ABC&color=fff`;
                }} data-id="element-1024" />
                    </div>
                    <div className="ml-4" data-id="element-1025">
                      <div className="text-sm font-medium text-gray-900" data-id="element-1026">
                        {payer.keyContacts[0].name}
                      </div>
                      <div className="text-xs text-gray-600" data-id="element-1027">
                        {payer.keyContacts[0].title}
                      </div>
                      <div className="mt-2 flex flex-col space-y-1" data-id="element-1028">
                        <a href={`mailto:${payer.keyContacts[0].email}`} className="text-xs text-blue-600 hover:text-blue-800" data-id="element-1029">
                          {payer.keyContacts[0].email}
                        </a>
                        <span className="text-xs text-gray-600" data-id="element-1030">
                          {payer.keyContacts[0].phone}
                        </span>
                      </div>
                    </div>
                  </div>}
                {/* Contact Type Buttons */}
                <div className="grid grid-cols-2 gap-2" data-id="element-1031">
                  {contactTypes.map((type, index) => <button key={index} className="flex items-center justify-center px-3 py-2 text-xs font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-md hover:bg-gray-100" data-id="element-1032">
                      <type.icon className="h-4 w-4 mr-2 text-gray-500" data-id="element-1033" />
                      {type.name}
                    </button>)}
                </div>
                {/* Additional Key Contacts (if any) */}
                {payer.keyContacts.length > 1 && <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-1034">
                    <h5 className="text-xs font-medium text-gray-700 mb-2" data-id="element-1035">
                      Additional Contacts
                    </h5>
                    <div className="space-y-3" data-id="element-1036">
                      {payer.keyContacts.slice(1).map((contact, index) => <div key={index} className="flex items-center" data-id="element-1037">
                          <div className="flex-shrink-0" data-id="element-1038">
                            <img src={contact.photo} alt={contact.name} className="h-8 w-8 rounded-full object-cover" onError={e => {
                      const target = e.target as HTMLImageElement;
                      target.onerror = null;
                      target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(contact.name)}&background=0D8ABC&color=fff`;
                    }} data-id="element-1039" />
                          </div>
                          <div className="ml-2" data-id="element-1040">
                            <div className="text-xs font-medium text-gray-900" data-id="element-1041">
                              {contact.name}
                            </div>
                            <div className="text-xs text-gray-600" data-id="element-1042">
                              {contact.title}
                            </div>
                          </div>
                        </div>)}
                    </div>
                  </div>}
              </div>

              {/* Medical Policy Information Section */}
              <div className="bg-white rounded-bl-lg rounded-br-lg lg:rounded-bl-none lg:rounded-tr-lg lg:rounded-br-lg shadow lg:w-1/3 p-6 border-t lg:border-t-0 border-gray-200" data-id="element-1043">
                <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-1044">
                  Medical Policy Information
                </h4>
                <div className="space-y-4" data-id="element-1045">
                  <div data-id="element-1046">
                    <h5 className="text-xs font-medium text-gray-700 mb-1" data-id="element-1047">
                      Policy Committee
                    </h5>
                    <p className="text-sm text-gray-900" data-id="element-1048">
                      {payer.policyInfo.committeeName || 'Not specified'}
                    </p>
                    <p className="text-xs text-gray-600" data-id="element-1049">
                      Meets {payer.policyInfo.meetingFrequency}
                    </p>
                  </div>
                  <div data-id="element-1050">
                    <h5 className="text-xs font-medium text-gray-700 mb-1" data-id="element-1051">
                      Policy Contact
                    </h5>
                    <a href={`mailto:${payer.policyInfo.policyContact}`} className="text-sm text-blue-600 hover:text-blue-800" data-id="element-1052">
                      {payer.policyInfo.policyContact}
                    </a>
                  </div>
                  <div className="flex items-start" data-id="element-1053">
                    <GlobeIcon className="h-5 w-5 text-gray-400 flex-shrink-0 mt-0.5" data-id="element-1054" />
                    <div className="ml-2" data-id="element-1055">
                      <h5 className="text-xs font-medium text-gray-700" data-id="element-1056">
                        Policy Website
                      </h5>
                      <a href={payer.policyInfo.policyWebsite} className="text-sm text-blue-600 hover:text-blue-800" target="_blank" rel="noopener noreferrer" data-id="element-1057">
                        Access Policies
                      </a>
                    </div>
                  </div>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1058">
                    <div data-id="element-1059">
                      <h5 className="text-xs font-medium text-gray-700" data-id="element-1060">
                        Review Schedule
                      </h5>
                      <p className="text-sm text-gray-900" data-id="element-1061">
                        {payer.policyInfo.reviewSchedule}
                      </p>
                    </div>
                    <div data-id="element-1062">
                      <h5 className="text-xs font-medium text-gray-700" data-id="element-1063">
                        Comment Period
                      </h5>
                      <p className="text-sm text-gray-900" data-id="element-1064">
                        {payer.policyInfo.commentPeriod}
                      </p>
                    </div>
                  </div>
                  <div data-id="element-1065">
                    <h5 className="text-xs font-medium text-gray-700" data-id="element-1066">
                      Next Review
                    </h5>
                    <p className="text-sm text-gray-900" data-id="element-1067">
                      {payer.policyInfo.nextReviewDate}
                    </p>
                  </div>
                  <div className="flex space-x-2" data-id="element-1068">
                    <button className="flex items-center justify-center px-3 py-2 text-xs font-medium text-blue-700 bg-blue-50 border border-blue-200 rounded-md hover:bg-blue-100" data-id="element-1069">
                      <FileTextIcon className="h-4 w-4 mr-2" data-id="element-1070" />
                      Policy Calendar
                    </button>
                    <button className="flex items-center justify-center px-3 py-2 text-xs font-medium text-green-700 bg-green-50 border border-green-200 rounded-md hover:bg-green-100" data-id="element-1071">
                      <CheckCircleIcon className="h-4 w-4 mr-2" data-id="element-1072" />
                      Submit Evidence
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {/* Expanded Notes Section */}
            {expandedPayer === payer.id && payer.notes && <div className="mt-1 bg-gray-50 border border-gray-200 rounded-b-lg p-4" data-id="element-1073">
                <h4 className="text-sm font-medium text-gray-900 mb-2" data-id="element-1074">
                  Notes
                </h4>
                <p className="text-sm text-gray-600" data-id="element-1075">{payer.notes}</p>
              </div>}
          </div>)}
      </div>

      {filteredPayers.length === 0 && <div className="bg-white rounded-lg shadow p-8 text-center" data-id="element-1076">
          <UsersIcon className="mx-auto h-12 w-12 text-gray-400" data-id="element-1077" />
          <h3 className="mt-2 text-sm font-medium text-gray-900" data-id="element-1078">
            No payers found
          </h3>
          <p className="mt-1 text-sm text-gray-500" data-id="element-1079">
            Try adjusting your search or filter criteria.
          </p>
        </div>}
    </div>;
};
export default PayerContacts;